export default {
  active: true,
  noticeBar: {
    settings: {}
  },
  defaultSettings: {
    timestamp: null,
    salesBarTheme: {
      // expect that the data / combinations will change here e.g sales bar vs modal theme
      mainTheme: 'museum',
      subsetTheme: 'dark-accent-1',
      subsetContrastTheme: 'type-1'
    },
    enabled: false,
    showNoticeBar: true,
    sitegateActive: false,
    sitegateWindow: 'content-sitegate',
    scheduled: false,
    scheduleStart: null,
    scheduleEnd: null,
    dismissable: false,
    autoDismiss: false,
    autoDismissTime: 5,
    noticeBarTitle: 'Free Shipping',
    noticeBarLead: 'On wine purchases over $100.',
    noticeBarIcon: 'shipping-icon-1', // optional appears on salesbar,  see sales-bar-icon component for allowed values
    noticeBarButtonActive: false,
    noticeBarButtonSize: 'standard',
    noticeBarButtonType: 'text-underline',
    noticeBarButtonStyle: 'outline',
    noticeBarButtonUrl: 'tel:1800677656',
    noticeBarButtonTitle: '1800 677 656',
    noticeBarButtonUrlNewWindow: true, // opens link in new window with rel no follow if true
    noticeBarButtonIcon: 'phone', // see highlight button component for allowed values
    noticeBarButtonIconPosition: 'right',
    noticeBarButtonBlock: false
  }
}
